module.exports = __webpack_public_path__ + "img/labelling.354e38e3.svg";